import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class TranslatesService {
  words = {
    address: ['direcciones'],
    address_by_id: ['direcciones por id de usuario'],
    city: ['ciudades'],
    country: ['países'],
    institution: ['instituciones'],
    material: ['materiales'],
    pathology: ['patologías'],
    pathologiesCountry: ['patologías por país'],
    pathology_country: ['patologías por país'],
    pathologiesCountryManifest: ['manifestaciones para patología por país'],
    pathology_country_manifest: ['manifestaciones para patología por país'],
    pathologiesCountryStudy: ['tipos de estudio para patología por país'],
    pathology_country_study: ['tipos de estudio para patología por país'],
    pathologySymptom: ['sintomas por patología'],
    pathology_symptom: ['sintomas por patología'],
    pathologyTest: ['tipos de prueba por patología'],
    pathology_test: ['tipos de prueba por patología'],
    studyTypesTestTypes: ['tipos de prueba por tipos de estudio'],
    study_types_test_types: ['tipos de prueba por tipos de estudio'],
    state: ['provincias'],
    specialty: ['especialidades'],
    studyTypeGather: ['tipos de estudio para retiro de muestras'],
    study_type_gather: ['tipos de estudio para retiro de muestras'],
    symptom: ['sintomas'],
    testType: ['tipos de prueba'],
    test_type: ['tipos de prueba'],
    event: ['eventos'],
    events: ['eventos'],
    sampleInfo: ['toma de muestra'],
    sample: ['toma de muestra'],
    gatherInfo: ['retiro de muestra'],
    gather: ['retiro de muestra'],
    kitInfo: ['kits de diagnostico'],
    kits: ['kits de diagnostico'],
    pathology_country_study_types: [''],
    SampleInfo: ['toma de muestra'],
    sample_by_user: ['toma de muestra por usuario'],
    gather_by_user: ['retiro de muestra por usuario'],
    get_kit_by_identification_user: ['kits de diagnostico por usuario'],
    GatherInfo: ['retiro de muestra'],
    change_password: ['cambio de contraseña'],
    update_profile: ['perfil'],
    signup: ['usuario desde el registro'],
    get_rol_by_country: ['roles por país'],
    home: ['inicio'],
    login: ['inicio de sesión'],
    profile: ['perfil'],
    configuration: ['configuración'],
    releases: ['despliegue'],
    'request-history': ['historial de solicitudes'],
    'new-gather': ['retiros de muestra'],
    'kit-request': ['kits de diagnostico'],
    'module-rol': ['permisos para el usuario']
  }
}
